import { parseNumeric } from "../../../helpers";

export const CurrencyColumn = ({ currency, moneda, decimals = 2 }) => {
  return (
    <>
      <b>
        {parseNumeric(currency).toFixed(decimals)}
        <small> {moneda}</small>
      </b>
    </>
  );
};
